export abstract class MediaBreakpoint {
  alias: 's' | 'm' | 'l' | 'xl';
  maxWidth: number;
  minWidth: number;
}
